import React from 'react';
import styled from 'styled-components';
import { FormattedMessage, FormattedCurrency } from 'i18n';
import Checkbox from 'components/inputs/Checkbox/CheckboxComponent';

function FlightSelectionComponent({ price, checked, onChange, onClick, airlineWhitelabel }) {
  const selectButtonTranslationKey = checked
    ? { id: 'selected.label', description: 'Selected', defaultMessage: 'Selected' }
    : { id: 'choose.label', description: 'Choose', defaultMessage: 'Choose' };

  return (
    <Root onClick={onClick} isChecked={checked}>
      <Price>
        <PriceValue airlineWhitelabel={airlineWhitelabel}>
          {price >= 0 && '+'}
          <FormattedCurrency value={price} />
        </PriceValue>
        <PriceInfoLabel>
          <FormattedMessage
            id={'pricePerPerson.label'}
            description={'Price per person'}
            defaultMessage={'Price per person'}
          />
        </PriceInfoLabel>
      </Price>
      <CheckboxWrap>
        <Checkbox rounded isChecked={checked} onChange={onChange} />
        <SelectionLabel checked={checked}>
          <FormattedMessage
            id={selectButtonTranslationKey.id}
            description={selectButtonTranslationKey.description}
            defaultMessage={selectButtonTranslationKey.defaultMessage}
          />
        </SelectionLabel>
      </CheckboxWrap>
    </Root>
  );
}

export default FlightSelectionComponent;

const Root = styled.div`
  display: flex;
  flex: 1 0 auto;
  width: 100%;
  padding: 20px;
  background-color: ${({ theme }) => theme.colors.background.light};
  border-top: 1px solid ${({ theme }) => theme.colors.background.greyV3};
  cursor: ${({ isChecked }) => (isChecked ? 'default' : 'pointer')};
`;

const Price = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 45%;
`;

const PriceValue = styled.div`
  order: 2;
  font-size: 3.2em;
  font-weight: ${({ airlineWhitelabel }) => (airlineWhitelabel && airlineWhitelabel.isAirBaltic ? 500 : 700)};
  text-align: left;
  color: ${({ theme }) => theme.colors.text.price};
`;

const PriceInfoLabel = styled.div`
  order: 1;
  font-size: 1.1em;
  font-weight: 500;
  line-height: 1.82;
  text-align: left;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text.light};
`;

const CheckboxWrap = styled.div`
  display: flex;
  align-self: center;
  margin-right: 18px;
`;

const SelectionLabel = styled.span`
  font-size: 1.6em;
  margin-left: 18px;
  margin-top: 4px;
  font-weight: ${({ theme, checked }) => (checked ? '700' : 'normal')};
`;
